<template>
    <div class="my-account__page">
        <SectionHeader :icon="`icon-user`">
            {{$t('my account') | upperCase}}
        </SectionHeader>
        <div class="my-account__container">
            <div class="left-container">
                <Balance
                    class="section"
                    :title="$t('account balance') "
                    :amount="userBalance"
                    :stakeInActiveTickets="stakeInActiveTickets"
                    :isStakeLoading="areTicketsLoading"
                />
                <div class="divider full" />
                <DepositAmountContainer
                    class="section"
                    :isTaxable="config.countrySpecific.user.deposit.isTaxable"
                    :showHelp="false"
                    :showWelcomeBonus="user.welcomeBonus"
                >
                    <SubtleLink :link= "{name: routeNames.deposit }">
                        {{ $t('other deposit options') | capitalize }}
                    </SubtleLink>
                </DepositAmountContainer>
                <div class="divider full" />
                <Withdrawal
                    class="section"
                    :amount="userBalanceWithBonus"
                />
            </div>
            <div class="right-container">
                <Bonus
                    :amount="userBonus"
                    class="section mb-2"
                />
                <div class="user-container">
                    <div class="divider" />
                    <ProfileDetails
                        :user="user"
                        class="section"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { routeNames } from '@app/router';
    import config from '@config';
    import Modals from '@store/modules/ui/shared/modal/modals';
    import { isIdCardVerificationPending } from '@models/user/UserDataService';
    import Bonus from '../components/Bonus.vue';
    import Balance from '../components/Balance.vue';
    import Withdrawal from '../components/Withdrawal';
    import DepositAmountContainer from '../deposit/shared/DepositAmountContainer.vue';
    import ProfileDetails from './components/ProfileDetails';

    export default {
        name: 'AccountContainer',
        data() {
            return {
                Modals,
            };
        },
        created() {
            this.config = config;
            this.setIsIdCardVerificationPending(isIdCardVerificationPending(this.user));
            this.routeNames = routeNames;
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
                'userBalance',
                'userBonus',
                'userBalanceWithBonus'
            ]),
            ...mapGetters('ui/user/account', [
                'isIdCardVerificationPending',
            ]),
            ...mapGetters('data/tickets', [
                'stakeInActiveTickets',
                'areTicketsLoading',
            ]),
        },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
            ]),
            ...mapActions('ui/user/account', [
                'setIsIdCardVerificationPending',
            ]),
        },
        components: {
            Withdrawal,
            Balance,
            DepositAmountContainer,
            Bonus,
            ProfileDetails
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/userProfile/account/AccountContainer.vue